import { AxiosInstance } from "axios";
import dayjs from "../utils/Dayjs";

/**
 * Variables which comes from the app clients and passed to the shared package
 */
interface Environment {
  dayjs: typeof dayjs;
  axios?: AxiosInstance;
  user?: object; // TODO: update with the real user interface
}

let environment: Environment | undefined = undefined;

/**
 * Gets the currently loaded variables from the app clients
 *
 * @returns {Environment} The environment variables
 */
export const getEnvironment = (): Environment => {
  if (!environment) throw new Error("Environment not initialized");
  return environment;
};

/**
 * Initializes the environment variables
 *
 * @param env The environment variables
 */
export const initEnvironment = (): void => {
  environment = { dayjs };
};

/**
 * Update specific environment variables like the user or the axios instance
 *
 * @param env The environment variables to update
 */
export const updateEnvironment = (env: Partial<Environment>): void => {
  if (!environment) throw new Error("Environment not initialized");
  environment = { ...environment, ...env };
};
